import {USER_LOGOUT} from '../../modules/auth/actions/types';
import {ACT_ACTION, CHANGE_ACT_EMAIL} from '../../modules/finance/actions/types';
import {USER_CHANGE} from "../../modules/food/actions/types";

const initialState = {
    salesDirections: [],
    error: '',
    currentDirection: null,
    begin: new Date(),
    end: new Date(),
    email: '',
    operations: [],
    payerFio: '',
    balanceText: '',
    totalText: '',
    text: '',
    emailError: '',
    phone: ''
};


export default (state = initialState, action = {}) => {
    if (action.type === ACT_ACTION) {
        return {...state, ...{...{error: '', operations: []}, ...action.payload, email: state.email ? state.email : action.payload.mail}};
    } else if (action.type === CHANGE_ACT_EMAIL) {
        return {...state, text: '', emailError: '', email: action.payload};
    }else if (action.type === 'SEND_ACT_EMAIL') {
        return {...state, text: '', emailError: '', ...action.payload};
    } else if (action.type === USER_LOGOUT) {
        return initialState;
    } else if (action.type === USER_CHANGE) {
        return {...state, ...{error: '', operations: []}};
    }

    return state;
};




/** WEBPACK FOOTER **
 ** ./src/redux/reducers/compAct.js
 **/